import {BaseModule, IModuleConfig} from "@kta20-core/interfaces/base-module";
import {IAppContext} from "@kta20-core/interfaces/i-app-context";
import {BridgeManager} from "@kta20-core/bridge-manager";
import {I_AUTH_BRIDGE} from "@kta20-core/interfaces/auth/i-auth-bridge";
import {AuthService} from "@kta20-auth-by-kt1/services/auth-service";
import {MODULE_CLASS_NAME} from "@kta20-auth-by-kt1/constants";

export class AuthByKT1Module extends BaseModule {

    static CLASS_NAME = MODULE_CLASS_NAME;

    static async factory(appContext: IAppContext, moduleConfig?: IModuleConfig): Promise<BaseModule> {
        appContext;moduleConfig;

        BridgeManager.get().addBridge(
            I_AUTH_BRIDGE,
            //if you later need to read user profile data pass here an implementation of IUserInfoAdapter specific for KT1
            AuthService.get(0,null,null)
        );

        return new AuthByKT1Module;
    };
}
